export const LOCATION_TYPES = [
  "Classroom",
  "Hallway",
  "Gym",
  "Cafeteria",
  "Library",
  "Office",
  "Restroom",
  "Playground",
  "Parking Lot",
  "Auditorium",
  "Kitchen",
  "Storage",
  "Outdoor",
  "Other",
];

// Suggested placeholder text per location type
export const LOCATION_HINT = {
  Classroom:    "Room #, e.g. Room 12",
  Hallway:      "Which hallway or wing",
  Gym:          "Main gym, small gym, locker rooms…",
  Cafeteria:    "Serving line, kitchen area, dining hall",
  Library:      "Reading area, computer bay, shelving row",
  Office:       "Main office, principal's office, counselor's",
  Restroom:     "Girls / boys / staff · location",
  Playground:   "Which yard or play structure",
  "Parking Lot": "Front / back / bus loop",
  Auditorium:   "Stage, seats, backstage",
  Kitchen:      "Prep area, dish room, walk-in",
  Storage:      "Room name / building",
  Outdoor:      "Field, garden, walkway…",
  Other:        "Describe the location",
};
